<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4N20A/4N20A.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">4N20A 2.0 Miller Cycle Engine</div>
        <div class="detail-banner-desc">
          The longitudinal 4N20A series is an evolution of the 4N20 technology, enhancing power performance while maintaining high thermal efficiency. Equipped with our longitudinal off-road vehicle platform, it delivers high energy, high efficiency, high reliability, and compatibility with various domestic and international fuels (91#/92#/95#/E100 flex fuel).
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">Core Specifications</div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">Maximum Power</div>
          <div class="detail-utils-u">180kW/6000rpm</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Maximum Torque</div>
          <div class="detail-utils-u">380N·m/1700~4000rpm</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Minimum BSFC</div>
          <div class="detail-utils-u">220g/kW·h</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Thermal Efficiency</div>
          <div class="detail-utils-u">38%</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Emission Standard</div>
          <div class="detail-utils-u">China 6b</div>
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">Core Technologies</div>
      <div class="detail-desc"></div>
      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4N20A/4N20A-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">High-Efficiency Combustion System</div>
          <div class="detail-four-desc">
            Miller cycle, high compression ratio, and direct injection. Features 350bar injection pressure and 90mJ high-energy ignition.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">Intelligent Thermal Management System</div>
          <div class="detail-four-desc">
            Mechanical pump and thermal management meet high cooling demands of off-road vehicles.<br />
            Dynamic flow and temperature control ensure fast response and reduced fuel consumption.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4N20A/4N20A-2.jpg" alt=""></div>
        </div>
      </div>

    </div>
    <div class="detail-swiper-list detail-box">
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/4N20A/4N20A-3.jpg" alt=""></img>
      </div>
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            P0 Mild Hybrid Architecture
          </div>
          <div class="detail-desc">
            Incorporates a 48V-BSG motor for auxiliary generation, smoother engine start-stop, accessory drive support, and idle speed reduction to improve fuel economy.
          </div>
        </div>
      </div>
    </div>
  </div>


  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4N20A 2.0 Miller Cycle Engine - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/engine/4N20A.html'

};

import { createApp } from 'vue';
import App from './4N20A.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4N20A.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>